import { Check, ArrowUpRight, Sparkles } from "lucide-react";
import { Reveal, scrollToId } from "@/components/Reveal";

const PLANS = [
  {
    name: "Başlangıç",
    segment: "Bireysel kullanım",
    price: "₺0",
    period: "/ay",
    desc: "Freelancer ve bireysel kullanıcılar için temel takip.",
    features: [
      "1 banka hesabı bağlantısı",
      "Gelir & gider takibi",
      "Aylık özet rapor",
      "Mobil erişim",
    ],
    cta: "Ücretsiz Başla",
    featured: false,
    testid: "pricing-card-baslangic",
    ctaTestid: "pricing-cta-baslangic",
  },
  {
    name: "Profesyonel",
    segment: "KOBİ'ler için",
    price: "₺490",
    period: "/ay",
    desc: "Büyüyen işletmeler için tam nakit akışı kontrolü.",
    features: [
      "Sınırsız banka & cari hesap",
      "Anlık nakit akışı grafiği",
      "Yaklaşan ödeme & tahsilat uyarıları",
      "Otomatik raporlar (PDF / Excel)",
      "E-fatura entegrasyonu",
      "3 kullanıcı dahil",
    ],
    cta: "Erken Erişim Al",
    featured: true,
    testid: "pricing-card-profesyonel",
    ctaTestid: "pricing-cta-profesyonel",
  },
  {
    name: "Kurumsal",
    segment: "Büyük ekipler için",
    price: "₺1.490",
    period: "/ay",
    desc: "Çok şubeli yapılar için gelişmiş kontrol ve destek.",
    features: [
      "Profesyonel'deki her şey",
      "Çoklu şube & şirket yönetimi",
      "API erişimi",
      "Özel rapor şablonları",
      "Öncelikli destek",
      "Sınırsız kullanıcı",
    ],
    cta: "Bize Ulaşın",
    featured: false,
    testid: "pricing-card-kurumsal",
    ctaTestid: "pricing-cta-kurumsal",
  },
];

const Pricing = () => (
  <section id="fiyatlandirma" data-testid="pricing-section" className="relative py-24 sm:py-32">
    <div className="pointer-events-none absolute left-1/2 top-24 h-[380px] w-[680px] -translate-x-1/2 rounded-full bg-emerald-500/8 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal className="mx-auto max-w-2xl text-center">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">
          Fiyatlandırma
        </div>
        <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
          Her ölçeğe uygun, şeffaf planlar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-400 sm:text-lg">
          Kredi kartı gerekmez. Erken erişim üyelerine lansman döneminde{" "}
          <span className="font-semibold text-emerald-400">3 ay ücretsiz</span> kullanım
          ve <span className="font-semibold text-emerald-400">ömür boyu %20 indirim</span>.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.testid} delay={0.08 + i * 0.1} className="h-full">
            <div
              data-testid={plan.testid}
              className={`relative flex h-full flex-col rounded-2xl border p-8 transition-all duration-500 hover:-translate-y-1.5 ${
                plan.featured
                  ? "border-emerald-400/50 bg-[#0D111A] shadow-[0_0_60px_rgba(0,255,135,0.12)]"
                  : "border-white/8 bg-[#0D111A] hover:border-emerald-400/30"
              }`}
            >
              {plan.featured && (
                <span className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-1 text-xs font-bold text-emerald-950">
                  <Sparkles className="h-3.5 w-3.5" />
                  En Popüler
                </span>
              )}
              <div className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
                {plan.segment}
              </div>
              <h3 className="font-display mt-2 text-2xl font-bold text-slate-50">{plan.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{plan.desc}</p>
              <div className="mt-6 flex items-baseline gap-1">
                <span className={`font-display text-4xl font-extrabold ${plan.featured ? "text-gradient-emerald" : "text-slate-50"}`}>
                  {plan.price}
                </span>
                <span className="text-sm text-slate-500">{plan.period}</span>
              </div>
              <ul className="mt-7 flex-1 space-y-3">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={plan.ctaTestid}
                onClick={() => scrollToId("#erken-erisim")}
                className={`group mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full py-3.5 text-sm font-semibold transition-all duration-300 ${
                  plan.featured
                    ? "bg-emerald-500 text-emerald-950 hover:bg-emerald-400 hover:shadow-[0_0_36px_rgba(0,255,135,0.4)]"
                    : "border border-white/15 text-slate-200 hover:border-emerald-400/50 hover:text-emerald-300"
                }`}
              >
                {plan.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Pricing;
